module.exports = __webpack_public_path__ + "static/media/No-Games-Found-Icon.de5933f5.svg";